import { ErrorCodes } from "../enums/error-code.enum";

export class ErrorModel {
  constructor(
      public code: string | ErrorCodes,
      public message: string,
  ) { }
}
